import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import { toast } from "react-toastify";

export const renderProfileImage = (studentInfo, userInfo) => {
  if (studentInfo?.profileImageUrl) {
    return `<img src="${studentInfo.profileImageUrl}" alt="profile" style="width:100%; height:100%; object-fit:cover;" />`;
  }
  if (studentInfo?.profile_image?.data) {
    try {
      const uint8Array = new Uint8Array(studentInfo.profile_image.data);
      const blob = new Blob([uint8Array], { type: "image/png" });
      const url = URL.createObjectURL(blob);
      return `<img src="${url}" alt="profile" style="width:100%; height:100%; object-fit:cover;" />`;
    } catch (e) {
      console.warn("Failed to create blob for staff image:", e);
    }
  }
  if (studentInfo?.profileimage) {
    return `<img src="${studentInfo.profileimage}" alt="profile" style="width:100%; height:100%; object-fit:cover;" />`;
  }
  const ts = Date.now();
  const pid = studentInfo?.file_parent_id;
  const fid = studentInfo?.file_id;
  const ftype = studentInfo?.file_type;
  const tenantcode = userInfo?.tenantcode;

  return `
    <img
      src="/uploads/${tenantcode}/${pid}/${fid}.${ftype}?v=${ts}"
      alt="profile"
      style="width:100%; height:100%; object-fit:cover;"
      onerror="
        if(!this.dataset.step){
          this.dataset.step='1';
          this.src='/uploads/${pid}/${fid}.${ftype}?v=${ts}';
        }else{
          this.onerror=null;
          this.src='/uploads/dwps_ajmer/image_2024102442318.png';
        }
      "
    />
  `;
};

export const getDefaultTemplate = (orientation = "vertical", defaultHeaderColor = "#424343", defaultTextColor = "#faf4f4") => {
  if (orientation === "vertical") {
    return {
      orientation: "vertical",
      width: 56, // mm (Standard 56mm x 88mm ratio)
      height: 88, // mm
      background: {
        color: "#ffffff",
        image: "",
      },
      elements: [
        {
          id: "header_box",
          type: "shape",
          label: "Header Box",
          x: 0,
          y: 0,
          width: 56,
          height: 6,
          backgroundColor: defaultHeaderColor || "#424343",
          borderColor: "transparent",
          borderWidth: 0,
          borderRadius: 0,
          zIndex: 1,
        },
        {
          id: "school_logo",
          type: "image",
          fieldKey: "schoolLogo",
          label: "School Logo",
          x: 21,
          y: 2,
          width: 12,
          height: 12,
          borderWidth: 1.5,
          borderColor: "#ffffff",
          borderRadius: 50,
          zIndex: 2,
        },
        {
          id: "school_name",
          type: "field",
          fieldKey: "schoolName",
          label: "School Name",
          textTransform: "uppercase",
          x: 2,
          y: 14.5,
          width: 50,
          height: 6.5,
          fontSize: 10,
          fontWeight: "bold",
          color: "#111111",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          zIndex: 2,
        },
        {
          id: "school_address",
          type: "field",
          fieldKey: "schoolAddress",
          label: "School Address",
          textTransform: "lowercase",
          x: 2,
          y: 21,
          width: 50,
          height: 6,
          fontSize: 6.5,
          fontWeight: "normal",
          color: "#333333",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          zIndex: 2,
        },
        {
          id: "school_phone",
          type: "field",
          fieldKey: "schoolPhone",
          label: "School Phone",
          prefix: "Phone No. ",
          x: 2,
          y: 27.5,
          width: 50,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#333333",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          zIndex: 2,
        },
        {
          id: "top_divider",
          type: "shape",
          label: "Divider Line",
          x: 0,
          y: 32,
          width: 54,
          height: 0,
          backgroundColor: "transparent",
          borderColor: "transparent",
          borderWidth: 0,
          borderRadius: 0,
          zIndex: 2,
        },
        {
          id: "profile_image",
          type: "image",
          fieldKey: "profileImage",
          label: "Student Photo",
          x: 15.5,
          y: 33.5,
          width: 23,
          height: 23,
          borderWidth: 0,
          borderColor: "transparent",
          borderRadius: 50,
          zIndex: 3,
        },
        {
          id: "student_name",
          type: "field",
          fieldKey: "studentName",
          label: "Student Name",
          x: 2,
          y: 57.5,
          width: 50,
          height: 5.5,
          fontSize: 10.5,
          fontWeight: "bold",
          color: "#111111",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "class_field",
          type: "field",
          fieldKey: "fullClass",
          label: "Class & Section",
          prefix: "Class : ",
          x: 5,
          y: 63.5,
          width: 44,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "father_name",
          type: "field",
          fieldKey: "fatherName",
          label: "Father's Name",
          prefix: "Father : ",
          x: 5,
          y: 67.5,
          width: 44,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "dob_field",
          type: "field",
          fieldKey: "registerDate",
          label: "Date of Birth",
          prefix: "DOB : ",
          x: 5,
          y: 71.5,
          width: 44,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "phone_field",
          type: "field",
          fieldKey: "phone",
          label: "Contact No",
          prefix: "Phone : ",
          x: 5,
          y: 75.5,
          width: 44,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "address_field",
          type: "field",
          fieldKey: "studentAddress",
          label: "Address",
          prefix: "Address : ",
          x: 5,
          y: 79.5,
          width: 44,
          height: 6.5,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "principal_sign",
          type: "image",
          fieldKey: "principalSignature",
          label: "Principal Sign.",
          text: "Principal Sign.",
          x: 28,
          y: 76.5,
          width: 23,
          height: 4,
          fontSize: 7,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "right",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "footer_box",
          type: "shape",
          label: "Footer Box",
          x: 0,
          y: 83,
          width: 56,
          height: 5,
          backgroundColor: defaultHeaderColor || "#424343",
          borderColor: "transparent",
          borderWidth: 0,
          borderRadius: 0,
          zIndex: 1,
        },
      ],
    };
  } else {
    // Horizontal preset (88mm x 56mm) - matching standard card ratio with header and footer
    return {
      orientation: "horizontal",
      width: 88,
      height: 56,
      background: {
        color: "#ffffff",
        image: "",
      },
      elements: [
        {
          id: "header_box",
          type: "shape",
          label: "Header Box",
          x: 0,
          y: 0,
          width: 88,
          height: 5,
          backgroundColor: defaultHeaderColor || "#424343",
          borderColor: "transparent",
          borderWidth: 0,
          borderRadius: 0,
          zIndex: 1,
        },
        {
          id: "school_logo",
          type: "image",
          fieldKey: "schoolLogo",
          label: "School Logo",
          x: 4,
          y: 5,
          width: 12,
          height: 12,
          borderWidth: 1.5,
          borderColor: "#ffffff",
          borderRadius: 50,
          zIndex: 2,
        },
        {
          id: "school_name",
          type: "field",
          fieldKey: "schoolName",
          label: "School Name",
          textTransform: "uppercase",
          x: 18,
          y: 5.5,
          width: 65,
          height: 5,
          fontSize: 10.5,
          fontWeight: "bold",
          color: "#111111",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 2,
        },
        {
          id: "school_address",
          type: "field",
          fieldKey: "schoolAddress",
          label: "School Address",
          textTransform: "lowercase",
          x: 18,
          y: 11,
          width: 65,
          height: 4.5,
          fontSize: 7,
          fontWeight: "normal",
          color: "#333333",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 2,
        },
        {
          id: "school_phone",
          type: "field",
          fieldKey: "schoolPhone",
          label: "School Phone",
          prefix: "Phone No. ",
          x: 18,
          y: 15.5,
          width: 65,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#333333",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 2,
        },
        {
          id: "top_divider",
          type: "shape",
          label: "Divider Line",
          x: 0,
          y: 20.5,
          width: 86,
          height: 0,
          backgroundColor: "transparent",
          borderColor: "transparent",
          borderWidth: 0,
          borderRadius: 0,
          zIndex: 2,
        },
        {
          id: "profile_image",
          type: "image",
          fieldKey: "profileImage",
          label: "Student Photo",
          x: 4,
          y: 23.5,
          width: 22,
          height: 26,
          borderWidth: 0,
          borderColor: "transparent",
          borderRadius: 8,
          zIndex: 3,
        },
        {
          id: "student_name",
          type: "field",
          fieldKey: "studentName",
          label: "Student Name",
          x: 28,
          y: 23.5,
          width: 56,
          height: 5,
          fontSize: 11,
          fontWeight: "bold",
          color: "#111111",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "class_field",
          type: "field",
          fieldKey: "fullClass",
          label: "Class & Section",
          prefix: "Class : ",
          x: 28,
          y: 29.5,
          width: 56,
          height: 4,
          fontSize: 8,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "father_name",
          type: "field",
          fieldKey: "fatherName",
          label: "Father's Name",
          prefix: "Father : ",
          x: 28,
          y: 34,
          width: 56,
          height: 4,
          fontSize: 8,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "dob_field",
          type: "field",
          fieldKey: "registerDate",
          label: "Date of Birth",
          prefix: "DOB : ",
          x: 28,
          y: 38.5,
          width: 56,
          height: 4,
          fontSize: 8,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "phone_field",
          type: "field",
          fieldKey: "phone",
          label: "Contact No",
          prefix: "Phone : ",
          x: 28,
          y: 43,
          width: 56,
          height: 4,
          fontSize: 8,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "address_field",
          type: "field",
          fieldKey: "studentAddress",
          label: "Address",
          prefix: "Address : ",
          x: 28,
          y: 47.5,
          width: 33,
          height: 6,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "left",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "principal_sign",
          type: "image",
          fieldKey: "principalSignature",
          label: "Principal Sign.",
          text: "Principal Sign.",
          x: 62,
          y: 45,
          width: 22,
          height: 4,
          fontSize: 7.5,
          fontWeight: "normal",
          color: "#222222",
          textAlign: "right",
          fontFamily: "Arial, sans-serif",
          zIndex: 3,
        },
        {
          id: "footer_box",
          type: "shape",
          label: "Footer Box",
          x: 0,
          y: 49,
          width: 86,
          height: 5,
          backgroundColor: defaultHeaderColor || "#424343",
          borderColor: "transparent",
          borderWidth: 0,
          borderRadius: 0,
          zIndex: 1,
        },
      ],
    };
  }
};

export const createCardDiv = (
  student,
  orientation = "vertical",
  tempColor = "#424343",
  textColor = "#faf4f4",
  showBloodGroup = false,
  userInfo = {}
) => {
  return createDynamicCardDiv(student, orientation, getDefaultTemplate(orientation, tempColor, textColor), userInfo);
};

export const createDynamicCardDiv = (
  student,
  orientation,
  templateSchema,
  userInfo = {}
) => {
  const studentInfo = student.student_info || student;
  const entityType = studentInfo.entityType || (studentInfo.staffname || studentInfo.recordtype || studentInfo.employee_id ? "staff" : "student");
  const div = document.createElement("div");
  const widthMm = Number(templateSchema?.width) || (orientation === "horizontal" ? 88 : 56);
  const heightMm = Number(templateSchema?.height) || (orientation === "horizontal" ? 56 : 88);

  div.style.cssText = `
    width: ${widthMm}mm;
    height: ${heightMm}mm;
    background-color: ${templateSchema?.background?.color || "#ffffff"};
    ${templateSchema?.background?.image ? `background-image: url(${templateSchema.background.image}); background-size: cover; background-position: center;` : ""}
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    border: 1px solid #d6d6d6;
    page-break-inside: avoid;
    break-inside: avoid;
  `;

  const getDynFieldValue = (fieldKey, element) => {
    switch (fieldKey) {
      case "studentName":
        return studentInfo.studentname || studentInfo.staffname || (studentInfo.firstname ? `${studentInfo.firstname || ""} ${studentInfo.lastname || ""}`.trim() : "N/A");
      case "registrationNo":
        if (entityType === "staff") {
          return studentInfo.registration_no || studentInfo.employee_id || (studentInfo.id ? `EMP-${studentInfo.id.split("-")[0].toUpperCase()}` : "N/A");
        }
        return studentInfo.registration_no || studentInfo.srno || studentInfo.formno || "N/A";
      case "fatherName":
        if (entityType === "staff") {
          return studentInfo.qualification || studentInfo.department || studentInfo.recordtype || "-";
        }
        return studentInfo.parentname || studentInfo.fathername || "N/A";
      case "dob":
      case "registerDate":
        return studentInfo.dateofbirth
          ? moment(studentInfo.dateofbirth).format("DD-MM-YYYY")
          : "N/A";
      case "phone":
        return studentInfo.phone || studentInfo.parentmobile || "N/A";
      case "studentAddress":
        return studentInfo.street || studentInfo.address || studentInfo.current_address || studentInfo.permanent_address || "-";
      case "fullClass": {
        if (entityType === "staff") {
          return studentInfo.designation || studentInfo.recordtype || "Staff / Employee";
        }
        const className = studentInfo.class_name || "";
        const sectionName = studentInfo.section_name || "";
        return sectionName ? `${className} [${sectionName}]` : (className || "-");
      }
      case "designation":
      case "recordtype":
        return studentInfo.designation || studentInfo.recordtype || "-";
      case "qualification":
      case "department":
        return studentInfo.qualification || studentInfo.department || "-";
      case "bloodGroup":
        return studentInfo.blood_group || studentInfo.bloodgroup || "-";
      case "session":
        return studentInfo.session || studentInfo.session_year || "N/A";
      case "adharnumber":
        return studentInfo.adharnumber || studentInfo.aadhar_no || "-";
      case "gender":
        return studentInfo.gender || "-";
      case "category":
        return studentInfo.category || "-";
      case "formno":
        return studentInfo.formno || "-";
      case "srno":
        return studentInfo.srno || "-";
      case "email":
        return studentInfo.email || "-";
      case "city":
        return studentInfo.city || "-";
      case "religion":
        return studentInfo.religion || "-";
      case "schoolName":
        return userInfo?.companyname || "School Name";
      case "schoolAddress":
        return `${userInfo?.companystreet || ""} ${userInfo?.companystate || ""} ${userInfo?.companypincode || ""}`.trim() || "School Address";
      case "schoolPhone":
        return userInfo?.companyphone || userInfo?.phone || "";
      case "staticText":
        return element.text ?? element.style?.text ?? "Text";
      default:
        return element.text ?? element.style?.text ?? element.label ?? "";
    }
  };

  if (templateSchema && Array.isArray(templateSchema.elements)) {
    templateSchema.elements.forEach((el) => {
      if (entityType === "staff" && el.fieldKey === "registrationNo") {
        return; // Hide Employee ID for staff completely based on requirements
      }

      if (el.entityTarget && el.entityTarget !== "all" && el.entityTarget !== entityType) {
        return;
      }

      const elDiv = document.createElement("div");

      const fontSize = el.fontSize ?? el.style?.fontSize ?? 10;
      const fontWeight = el.fontWeight ?? el.style?.fontWeight ?? "normal";
      const color = el.color ?? el.style?.color ?? "#000000";
      const textAlign = el.textAlign ?? el.style?.textAlign ?? "left";
      const fontFamily = el.fontFamily ?? el.style?.fontFamily ?? "Arial, sans-serif";
      const backgroundColor = el.backgroundColor ?? el.style?.backgroundColor ?? "transparent";
      const borderRadiusVal = el.borderRadius ?? el.style?.borderRadius ?? 0;
      const borderRadiusStr = `${borderRadiusVal}${borderRadiusVal === 50 ? "%" : "px"}`;
      const borderWidth = el.borderWidth ?? el.style?.borderWidth ?? 0;
      const borderColor = el.borderColor ?? el.style?.borderColor ?? "transparent";
      const borderWidthBottom = el.borderWidthBottom ?? el.style?.borderWidthBottom ?? 0;
      const prefix = el.prefix ?? el.style?.prefix ?? "";
      const suffix = el.suffix ?? el.style?.suffix ?? "";
      const textTransform = el.textTransform ?? el.style?.textTransform ?? "none";

      let effectivePrefix = prefix || "";
      if (entityType === "staff") {
        if (el.fieldKey === "fullClass" && (effectivePrefix.toLowerCase().includes("class") || effectivePrefix === "")) {
          effectivePrefix = effectivePrefix.includes(":") ? "Role : " : "Role: ";
        } else if (el.fieldKey === "fatherName" && effectivePrefix.toLowerCase().includes("father")) {
          effectivePrefix = effectivePrefix.includes(":") ? "Dept/Qual : " : "Dept: ";
        } else if (el.fieldKey === "registrationNo" && (effectivePrefix.toLowerCase().includes("reg") || effectivePrefix.toLowerCase().includes("roll"))) {
          effectivePrefix = effectivePrefix.includes(":") ? "Emp ID : " : "Emp ID: ";
        }
      }

      const applyCase = (text, transform) => {
        if (!text || typeof text !== "string") return text || "";
        if (transform === "uppercase") return text.toUpperCase();
        if (transform === "lowercase") return text.toLowerCase();
        if (transform === "capitalize") {
          return text.replace(/\b\w/g, (char) => char.toUpperCase());
        }
        return text;
      };

      const elBorderWidth = Number(borderWidth) || 0;
      const elBorderBottomWidth = Number(borderWidthBottom) || 0;
      const topBorder = elBorderWidth > 0 ? `${elBorderWidth}px solid ${borderColor}` : "none";
      const rightBorder = elBorderWidth > 0 ? `${elBorderWidth}px solid ${borderColor}` : "none";
      const leftBorder = elBorderWidth > 0 ? `${elBorderWidth}px solid ${borderColor}` : "none";
      const bottomBorder = (elBorderBottomWidth > 0 || elBorderWidth > 0)
        ? `${Math.max(elBorderBottomWidth, elBorderWidth)}px solid ${borderColor}`
        : "none";

      elDiv.style.cssText = `
        position: absolute;
        left: ${el.x}mm;
        top: ${el.y}mm;
        width: ${el.width}mm;
        height: ${el.height}mm;
        z-index: ${el.zIndex || 1};
        box-sizing: border-box;
        background-color: ${backgroundColor};
        border-radius: ${borderRadiusStr};
        border-top: ${topBorder};
        border-right: ${rightBorder};
        border-bottom: ${bottomBorder};
        border-left: ${leftBorder};
        text-transform: ${textTransform};
        overflow: hidden;
        display: flex;
        align-items: ${el.type === "image" ? "center" : "flex-start"};
        justify-content: ${textAlign === "center"
          ? "center"
          : textAlign === "right"
            ? "flex-end"
            : "flex-start"
        };
      `;

      const isSignImage = (el.fieldKey === "principalSignature" || el.type === "image") && (el.imageUrl || (el.text && (el.text.startsWith("data:") || el.text.startsWith("http") || el.text.startsWith("/"))));
      if ((el.type === "field" || el.type === "text") && !isSignImage) {
        const rawVal = applyCase(getDynFieldValue(el.fieldKey, el), textTransform);
        const prefixStr = applyCase(effectivePrefix || "", textTransform);
        const suffixStr = applyCase(suffix || "", textTransform);
        const hasColon = prefixStr.includes(":");
        const isTableRowOrHasPrefix = prefixStr.trim().length > 0;

        const isMultiLine = el.fieldKey?.toLowerCase().includes("address") || Number(el.height) > 5.5 || el.wordBreak === "break-word" || el.style?.wordBreak === "break-word";

        if (isTableRowOrHasPrefix && (hasColon || Number(borderWidthBottom) > 0)) {
          const labelText = hasColon
            ? prefixStr.substring(0, prefixStr.indexOf(":")).trim()
            : prefixStr.trim();
          const colonDisplay = hasColon ? ":" : (Number(borderWidthBottom) > 0 && labelText ? ":" : "");

          elDiv.style.display = "flex";
          elDiv.style.alignItems = "flex-start";
          elDiv.style.fontSize = `${fontSize}px`;
          elDiv.style.fontWeight = fontWeight;
          elDiv.style.color = color;
          if (fontFamily) elDiv.style.fontFamily = fontFamily;
          elDiv.style.lineHeight = "1.18";
          elDiv.style.padding = "1px 2px";

          const labelDiv = document.createElement("div");
          labelDiv.style.cssText = `
            display: flex;
            justify-content: space-between;
            width: 37%;
            flex-shrink: 0;
            padding-right: 6px;
            box-sizing: border-box;
            font-size: ${fontSize}px;
            font-weight: ${fontWeight};
            color: ${color};
            ${fontFamily ? `font-family: ${fontFamily};` : ""}
          `;
          const labelSpan = document.createElement("span");
          labelSpan.style.cssText = `
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: ${fontSize}px;
            font-weight: ${fontWeight};
            color: ${color};
            ${fontFamily ? `font-family: ${fontFamily};` : ""}
          `;
          labelSpan.innerText = labelText;
          const colonSpan = document.createElement("span");
          colonSpan.style.cssText = `
            font-size: ${fontSize}px;
            font-weight: ${fontWeight};
            color: ${color};
            ${fontFamily ? `font-family: ${fontFamily};` : ""}
          `;
          colonSpan.innerText = colonDisplay;
          labelDiv.appendChild(labelSpan);
          labelDiv.appendChild(colonSpan);

          const valDiv = document.createElement("div");
          valDiv.style.cssText = `
            flex: 1;
            word-break: ${isMultiLine ? "break-word" : "normal"};
            white-space: ${isMultiLine ? "normal" : "nowrap"};
            overflow: hidden;
            text-overflow: ${isMultiLine ? "clip" : "ellipsis"};
            padding-left: 2px;
            box-sizing: border-box;
            font-size: ${fontSize}px;
            font-weight: ${fontWeight};
            color: ${color};
            ${fontFamily ? `font-family: ${fontFamily};` : ""}
          `;
          valDiv.innerText = `${rawVal}${suffixStr}`;

          elDiv.appendChild(labelDiv);
          elDiv.appendChild(valDiv);
        } else {
          const displayVal = `${prefixStr}${rawVal}${suffixStr}`;
          elDiv.style.fontSize = `${fontSize}px`;
          elDiv.style.fontWeight = fontWeight;
          elDiv.style.color = color;
          elDiv.style.textAlign = textAlign;
          if (fontFamily) elDiv.style.fontFamily = fontFamily;
          elDiv.style.padding = "1px 2px";
          elDiv.style.whiteSpace = isMultiLine ? "normal" : "nowrap";
          elDiv.style.wordBreak = isMultiLine ? "break-word" : "normal";
          elDiv.style.textOverflow = isMultiLine ? "clip" : "ellipsis";
          elDiv.style.lineHeight = "1.15";
          elDiv.innerText = displayVal;
        }
      } else if (el.type === "image" || el.fieldKey === "principalSignature") {
        if (el.fieldKey === "profileImage") {
          elDiv.innerHTML = renderProfileImage(studentInfo, userInfo);
        } else if (el.fieldKey === "schoolLogo") {
          elDiv.innerHTML = `<img src="/${userInfo?.tenantcode || "dwps_ajmer"}-sidebar-logo.png" style="width:100%; height:100%; object-fit:contain;" onerror="this.src='/uploads/dwps_ajmer/image_2024102442318.png'" />`;
        } else if (el.fieldKey === "principalSignature") {
          const signUrl = el.imageUrl || (el.text && (el.text.startsWith("data:") || el.text.startsWith("http") || el.text.startsWith("/"))) ? (el.imageUrl || el.text) : userInfo?.principalSignature || "";
          if (signUrl) {
            elDiv.innerHTML = `<img src="${signUrl}" style="width:100%; height:100%; object-fit:contain;" />`;
          } else {
            elDiv.style.fontSize = `${el.fontSize || 9}px`;
            elDiv.style.lineHeight = "1.15";
            elDiv.innerText = "Principal Sign.";
          }
        } else {
          const imgUrl = el.imageUrl || (el.text && (el.text.startsWith("data:") || el.text.startsWith("http") || el.text.startsWith("/"))) ? (el.imageUrl || el.text) : "";
          if (imgUrl) {
            elDiv.innerHTML = `<img src="${imgUrl}" style="width:100%; height:100%; object-fit:contain;" />`;
          }
        }
      } else if (el.type === "shape") {
        // Shape background, border, and radius are handled in container cssText above
      }

      div.appendChild(elDiv);
    });
  }

  return div;
};

export const generateAndDownloadIDCards = async ({
  students = [],
  orientation = "vertical",
  dynamicSchema = null,
  tempColor = "#d1b2b2",
  textColor = "#faf4f4",
  showBloodGroup = false,
  userInfo = {}
}) => {
  if (!students || students.length === 0) {
    toast.warning("No students selected to generate ID cards!");
    return;
  }

  console.log("orientation", orientation)
  console.log("orientation", typeof orientation)

  const isHorizontal = orientation === "horizontal";
  const CARD_WIDTH = Number(dynamicSchema?.width) || (isHorizontal ? 88 : 56);
  const CARD_HEIGHT = Number(dynamicSchema?.height) || (isHorizontal ? 56 : 88);

  // Page Setup according to Page Setup Size Ratio (Landscape A4: 297mm x 210mm):
  // Vertical (56mm x 88mm): 5 cards x 2 rows = 10 cards per sheet
  // Left: 4.5mm, Right: 4.5mm, Column Gap: 2mm (4.5 + 5x56 + 4x2 + 4.5 = 297mm)
  // Top: 14.5mm, Bottom: 14.5mm, Row Gap: 5mm (14.5 + 2x88 + 5 + 14.5 = 210mm)
  const pdfOrientation = "landscape";
  const PAGE_WIDTH = 297;
  const PAGE_HEIGHT = 210;

  const CARDS_PER_ROW = isHorizontal ? 3 : 5;
  const ROWS_PER_PAGE = isHorizontal ? 3 : 2;
  const CARDS_PER_PAGE = CARDS_PER_ROW * ROWS_PER_PAGE;

  const HORIZONTAL_GAP = isHorizontal ? 5 : 2;
  const marginLeft = isHorizontal
    ? Math.max(2, (PAGE_WIDTH - (CARDS_PER_ROW * CARD_WIDTH + (CARDS_PER_ROW - 1) * HORIZONTAL_GAP)) / 2)
    : 4.5;

  const spacingY = isHorizontal ? 6 : 5;
  const marginTop = isHorizontal
    ? Math.max(4, (PAGE_HEIGHT - (ROWS_PER_PAGE * CARD_HEIGHT + (ROWS_PER_PAGE - 1) * spacingY)) / 2)
    : 14.5;

  const totalCards = students.length;
  const totalPages = Math.ceil(totalCards / CARDS_PER_PAGE);

  const pdf = new jsPDF({ orientation: pdfOrientation, unit: "mm", format: "a4" });

  for (let pageNum = 0; pageNum < totalPages; pageNum++) {
    const startIdx = pageNum * CARDS_PER_PAGE;
    const endIdx = Math.min(startIdx + CARDS_PER_PAGE, totalCards);
    const cardsForThisPage = students.slice(startIdx, endIdx);
    const pageContainer = document.createElement("div");

    pageContainer.style.cssText = `
      width: ${PAGE_WIDTH}mm;
      height: ${PAGE_HEIGHT}mm;
      background: white;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999999;
      pointer-events: none;
      box-sizing: border-box;
      overflow: hidden;
    `;
    const gridContainer = document.createElement("div");
    gridContainer.style.cssText = `position: relative; width: ${PAGE_WIDTH}mm; height: ${PAGE_HEIGHT}mm; box-sizing: border-box;`;

    cardsForThisPage.forEach((student, idx) => {
      const card = dynamicSchema
        ? createDynamicCardDiv(student, orientation, dynamicSchema, userInfo)
        : createCardDiv(student, orientation, tempColor, textColor, showBloodGroup, userInfo);
      const row = Math.floor(idx / CARDS_PER_ROW);
      const col = idx % CARDS_PER_ROW;

      const x = marginLeft + col * (CARD_WIDTH + HORIZONTAL_GAP);
      const y = marginTop + row * (CARD_HEIGHT + spacingY);

      card.style.position = "absolute";
      card.style.left = `${x}mm`;
      card.style.top = `${y}mm`;
      gridContainer.appendChild(card);
    });

    pageContainer.appendChild(gridContainer);
    document.body.appendChild(pageContainer);

    await Promise.all(
      Array.from(pageContainer.getElementsByTagName("img")).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve;
          }
        });
      })
    );

    const containerWidth = pageContainer.offsetWidth || 1123;
    const containerHeight = pageContainer.offsetHeight || 794;

    const canvas = await html2canvas(pageContainer, {
      scale: 2,
      backgroundColor: "#ffffff",
      logging: false,
      useCORS: true,
      allowTaint: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: Math.max(1600, containerWidth + 200),
      windowHeight: Math.max(1200, containerHeight + 200),
      width: containerWidth,
      height: containerHeight,
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.85);

    if (pageNum === 0) {
      pdf.addImage(imgData, "JPEG", 0, 0, PAGE_WIDTH, PAGE_HEIGHT);
    } else {
      pdf.addPage([PAGE_WIDTH, PAGE_HEIGHT], pdfOrientation);
      pdf.addImage(imgData, "JPEG", 0, 0, PAGE_WIDTH, PAGE_HEIGHT);
    }

    document.body.removeChild(pageContainer);
  }

  const firstStudent = students[0] || {};
  const firstInfo = firstStudent.student_info || firstStudent;
  const isStaffBatch = firstInfo.entityType === "staff" || firstInfo.staffname || firstInfo.recordtype;
  const filePrefix = isStaffBatch ? "Employee_ID_Cards" : "Student_ID_Cards";
  pdf.save(`${filePrefix}_${orientation}_${moment().format("DD-MM-YYYY")}.pdf`);
};
